import React, {Component} from 'react'
import ForgetForm from './ForgetForm'
import {Actions} from 'jumpstate'
import {Form} from 'react-form'
import ErrorHandler from '../../utils/ErrorHandler'
import showToastr from '../../utils/showToastr'
import validateForgetPassword from '../../utils/validateForgetPassword'

class ForgetPasswordScreen extends Component {
  constructor (props) {
    super(props)
    this.state = {
      message: {status: '', context: ''},
      isLoading: false
    }
  }
  render () {
    const {message, isLoading} = this.state
    return (
      <Form
        ref="forgetForm"
        validate={validateForgetPassword}
        message={message}
        isLoading={isLoading}
        disable={isLoading}
        onSubmit={(values) => {
          this.setState({isLoading: true})
          Actions.forgetPassword(values).then(res => {
            this.setState({isLoading: false})
            showToastr('success', 'فراموشی رمز عبور', res.data.messages[0])
          }).catch((err) => {
            let eh = new ErrorHandler(err)
            this.setState({message: eh.message, isLoading: false})
            eh.setFormErrors(this.refs.forgetForm)
            eh.showToastrIn('فراموشی رمز عبور')
          })
        }}>
        {ForgetForm}
      </Form>
    )
  }
}

export default ForgetPasswordScreen



// WEBPACK FOOTER //
// ./src/components/ForgetPassword/ForgetPasswordScreen.js